import { render } from "./NewEmailBtn.vue?vue&type=template&id=6ea8f4dc&scoped=true"
import script from "./NewEmailBtn.vue?vue&type=script&lang=js"
export * from "./NewEmailBtn.vue?vue&type=script&lang=js"

import "./NewEmailBtn.vue?vue&type=style&index=0&id=6ea8f4dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea8f4dc"]])

export default __exports__